export const LOGIN = 'User/LOGIN'
export const LOGGED_IN = 'User/LOGGED_IN'
export const NOT_LOGGED_IN = 'User/NOT_LOGGED_IN'
export const LOGIN_SUCCESSFUL = 'User/LOGIN_SUCCESSFUL'
